// extracted by mini-css-extract-plugin
export default {"Header":"Header-styles__Header__kiaR5","Header__title":"Header-styles__Header__title__KWG_4","Header__subtitle":"Header-styles__Header__subtitle__Y8EVy"};